<section class="sg-container newsUpdateDialog">
    <form [formGroup]="newsUpdatesForm" novalidate autocomplete="off">
        <div class="row m-0 border-bottom p-3">
            <h1 mat-dialog-title class="mb-0 pl-2">{{modalHeaderTitle}}</h1>
        </div>
        <main mat-dialog-content class="sg-dialog-content py-3">

            <div class="row">
                <div class="col-3 pt-3 pr-0 sg-field-label-align">
                    <label class="sg-form-field-label">Start Date<span
                            class="sg-form-field-required-marker ml-1">*</span>
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template1" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template1 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> Date where this item will start showing in Home page
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </label>
                </div>
                <div class="col-9 pt-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput [min]="tomorrow" [matDatepicker]="picker" formControlName="startDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-3 pt-3 pr-0 sg-field-label-align">
                    <label class="sg-form-field-label">Days to Show<span
                            class="sg-form-field-required-marker ml-1">*</span>
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template2" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template2 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> after this Quantity of calendar days, this item will be hidden from Home
                                            page
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </label>
                </div>
                <div class="col-9 pt-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="daytoShow" type="text" placeholder="Day to show"
                            aria-label="Name" maxlength="2">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-3 pt-3 pr-0 sg-field-label-align">
                    <label class="sg-form-field-label">Type<span class="sg-form-field-required-marker ml-1">*</span>
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template3" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template3 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> This will change the icon shown for this item
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </label>
                </div>
                <div class="col-9 pt-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="Select the type" formControlName="type" [(ngModel)]="typeSelected" class="sg-select-sup">
                            <mat-option *ngFor="let option of  typeOptions" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="!isEditNewsUpdate">
                <div class="col-3 pr-0 sg-field-label-align">
                </div>
                <div class="col-9">
                    <mat-checkbox formControlName="highImportant" class="">High Importance
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template4" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template4 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> This will highlight the item as !important
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </mat-checkbox>
                </div>
            </div>

            <div class="row" *ngIf="isEditNewsUpdate">
                <div class="col-3 pr-0 sg-field-label-align">
                </div>
                <div class="col-9">
                    <mat-checkbox formControlName="isUrgent" class="">Is urgent?
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template5" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template5 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> This will highlight the item as !important
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </mat-checkbox>
                </div>
            </div>

            <div class="row" *ngIf="isEditNewsUpdate">
                <div class="col-3 pr-0 sg-field-label-align">
                </div>
                <div class="col-9">
                    <mat-checkbox formControlName="isDeleted" class="">Is Deleted?
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template6" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template6 class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> An item can be marked as deleted when the record is not needed <br>
                                            anymore Similar to "Is Active" in other admin screens
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </mat-checkbox>
                </div>
            </div>

            <div class="mb-0 mx-0 mb-3 mat-dialog-title">Contents</div>

            <div class="row">
                <div class="col-3 pt-2 pr-0">
                    <label class="sg-form-field-label">Title</label>
                    <span class="sg-form-field-required-marker ml-1">*</span>
                </div>
                <div class="col-9 pl-4">
                    <mat-form-field appearance="outline" class="w-100 sg-validation cws-error-container">
                        <input matInput type="text" formControlName="title">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-3 pt-3 pr-0">
                    <label class="sg-form-field-label">Description</label>
                    <span class="sg-form-field-required-marker ml-1">*</span>
                </div>
                <div class="col-9 pt-3 pl-4">
                    <mat-form-field appearance="outline" class="w-100 sg-validation cws-error-container">
                        <textarea matInput type="text" rows="10" cols="50" formControlName="description"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <div class="mb-0 mx-0 mt-3 mb-3 mat-dialog-title">Link List</div>

            <div class="row col-12 px-0 mx-0" formGroupName="linkListGroup">
                <div class="col-4 pl-0 pt-2 pr-2">
                    <div class="row mx-0">
                        <label class="sg-form-field-label pl-0">Link Name</label>
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> This name will be the visible link name in the Home Page
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </div>
                    <div class="row mx-0 pt-1 mb-0 pb-0">
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput type="text" formControlName="linkName">
                        </mat-form-field>
                    </div>

                </div>
                <div class="col-3 pt-2">
                    <div class="row mx-0 pb-2">
                        <label class="sg-form-field-label pl-2">Link Type</label>
                    </div>
                    <div class="row mx-0 pt-1 px-0">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-select formControlName="linkType" [(ngModel)]="linkTypeSelected"
                                (selectionChange)="onOptionChange($event)">
                                <mat-option *ngFor="let option of  linkTypeOptions" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-4 pt-2" *ngIf="linkTypeSelected == 'URL'">
                    <div class="row">
                        <label class="sg-form-field-label">URL</label>
                        <span class="sg-infoicon icon-position">
                            <p class="material-icons-outlined" [tooltip]="template" contentType="template"
                                [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                            </p>
                            <ng-template #template class="w-100">
                                <div class="row mx-0 w-100">
                                    <div class="col-12 w-100 px-0">
                                        <span> This name will be the visible link name in the Home Page
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </span>
                    </div>
                    <div class="row pt-1 pr-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput type="text" formControlName="url">
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-4 pr-0 pl-2" *ngIf="linkTypeSelected == 'Document'">
                    <div class="row mt-5">
                        <input type="file" id="myfile" name="Browse" class="sg-read-more" (change)="onFileSelected($event)"
                            formControlName="fileUpload">
                        <mat-error *ngIf="isExtensionNotValid">
                            The file extension is not allowed.
                        </mat-error>
                    </div>
                </div>
                <div class="col-1 pl-2 mt-5 d-flex justify-content-center">
                    <mat-icon class="gc-edit pointer-cursor mat-primary"
                     style="cursor: pointer;"  [ngClass]="payloadArray.enabled !== true ? 'disable-icon' : 'enable-icon'"
                     (click)="onUploadFile()">add_circle</mat-icon>
                </div>
            </div>

            <div class="row mx-0">
               
                <div class="col-12" *ngFor="let item of  linkList; let i = index">
               <u class="sg-read-more ">
                    <a target="_blank" href="item.linkAddress">{{item.linkTitle}}</a>
                </u>
                <span class="material-icons-outlined pointer-cursor mat-primary pl-2" (click)="removeLinkList(i)">close</span> 
            </div>
            </div>



        </main>
        <div class="border-top row mx-0 justify-content-end" mat-dialog-actions>
            <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
                *ngIf="!isEditNewsUpdate"
                type="button" [disabled]="newsUpdatesForm.invalid"
                (click)="isEditNewsUpdate ? onUpdateClick() : onSaveClick()">Save</button>
            <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
                *ngIf="isEditNewsUpdate"
                type="button" [disabled]=" enableButtonOnCrossClick ? (!newsUpdatesForm.dirty || newsUpdatesForm.invalid) :
                (enableButtonOnCrossClick)"
                (click)="onUpdateClick()">Save</button>
            <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button" type="button"
                (click)="onCancelClick()">Cancel</button>
        </div>
    </form>
</section>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>